<link rel="stylesheet" type="text/css" *ngIf="branding.css_file_url" [href]="brandingCssUrl"/>
<div id="header_height">
<nav class="navbar navbar-default top-nav nav-tenant">
  <div class="container-fluid navbar-collapse-tenant">
    <div class="navbar-header">
      <a href=""
         class="info show-mobile"
         data-toggle="modal"
         data-target=".support" title="Support Centre">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDM0IDM0IiBoZWlnaHQ9IjM0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzNCAzNCIgd2lkdGg9IjM0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxwYXRoIGQ9Ik0xNy4xMjMsOS4yYy0xLjQ0LDAtMi42NDIsMC41MDMtMy42MDQsMS4zMlMxMS45OTQsMTIsMTEuODMyLDE0aDIuOTM3YzAuMDY0LTEsMC4zMDMtMS4yMzEsMC43MTYtMS42MTEgICBzMC45MjYtMC42MTgsMS41NDEtMC42MThjMC42MTUsMCwxLjExNiwwLjE3NCwxLjUwNCwwLjU3MWMwLjM4OSwwLjM5NiwwLjU4MywwLjg4MiwwLjU4MywxLjQ4cy0wLjE4NywxLjA5NC0wLjU1OCwxLjQ5OSAgIGwtMS43NzIsMS43NjljLTAuNTE4LDAuNTE4LTAuNjI2LDAuOTM0LTAuNzgsMS4yNDlDMTUuODQ5LDE4LjY1NCwxNiwxOS4xMzMsMTYsMTkuNzhWMjFoMnYtMC44MzJjMC0wLjY0NiwwLjI4OS0xLjE0OCwwLjU4MS0xLjUwNCAgIGMwLjExMi0wLjEyOSwwLjMzMy0wLjI4NywwLjUyMS0wLjQ3M2MwLjE4Ni0wLjE4NywwLjQ0OC0wLjQwNSwwLjcxNS0wLjY1NmMwLjI2Ny0wLjI1LDAuNS0wLjQ1NywwLjY2Mi0wLjYxOSAgIGMwLjE2MS0wLjE2MSwwLjQwNC0wLjQzNywwLjcxMi0wLjgyNWMwLjUzMy0wLjY0NywwLjgwNS0xLjQ1NiwwLjgwNS0yLjQyN2MwLTEuNDA4LTAuNDUtMi41MDMtMS4zNTYtMy4yODkgICBDMTkuNzMyLDkuNTkyLDE4LjU2Myw5LjIsMTcuMTIzLDkuMnoiIGZpbGw9IiMyMzFGMjAiLz48cGF0aCBkPSJNMTYuOTQsMjIuMTQ1Yy0wLjUxLDAtMC45NDYsMC4xNzktMS4zMTEsMC41MzRjLTAuMzY0LDAuMzU2LTAuNTQ2LDAuNzgtMC41NDYsMS4yNzQgICBjMCwwLjQ5MywwLjE4NiwwLjkxNCwwLjU1OCwxLjI2MmMwLjM3MiwwLjM0OCwwLjgxMywwLjUyMSwxLjMyMiwwLjUyMWMwLjUxLDAsMC45NDctMC4xNzgsMS4zMTEtMC41MzMgICBjMC4zNjMtMC4zNTYsMC41NDYtMC43ODEsMC41NDYtMS4yNzRzLTAuMTg3LTAuOTE0LTAuNTU5LTEuMjYzQzE3Ljg5MSwyMi4zMTgsMTcuNDUsMjIuMTQ1LDE2Ljk0LDIyLjE0NXoiIGZpbGw9IiMyMzFGMjAiLz48cGF0aCBkPSJNMTcsMEM3LjYxMSwwLDAsNy42MTEsMCwxN3M3LjYxMSwxNywxNywxN3MxNy03LjYxMSwxNy0xN1MyNi4zODksMCwxNywweiBNMTcsMzFDOS4yNjgsMzEsMywyNC43MzIsMywxNyAgIEMzLDkuMjY4LDkuMjY4LDMsMTcsM2M3LjczMiwwLDE0LDYuMjY4LDE0LDE0QzMxLDI0LjczMiwyNC43MzIsMzEsMTcsMzF6IiBmaWxsPSIjMjMxRjIwIi8+PC9nPjwvc3ZnPg=="/>
      </a>
      <button type="button"
              appIsMobile
              class="navbar-toggle"
              data-toggle="collapse"
              data-target="#navbar-collapse-1-ng">
        <span class="sr-only">{{t('toggle')}}</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand logo" href="/#/dashboard" style="padding: 2px">
        <img src="{{branding.nav_logo_file_url}}" height="47"/>
      </a>
    </div>
    <div class="navbar-collapse" appIsMobile>
      <ul class="nav navbar-nav icon-md nav-mobile">
        <li class="hide-mobile">
          <a href="javascript:history.back()" [ngStyle]="linkStyle()">
            <span class="glyphicon glyphicon-chevron-left"></span>
          </a>
        </li>
        <li class="icon1" *ngIf="authUser.user_permissions.payments" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(0)}">
          <a href="/#/payments/schedule/create/" title="Payments" [ngStyle]="linkStyle()">
            <i class="fas fa-credit-card"></i>
            <span class="icon-sub show-mobile">{{t('payments')}}</span>
          </a>
        </li>
        <li class="icon7" *ngIf="authUser.user_permissions['maintenance-requests']" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(1)}">
          <a href="/#/maintenance-requests" title="Maintenance Requests" [ngStyle]="linkStyle()">
            <i class="fas fa-wrench"></i>
            <span class="icon-sub show-mobile">{{t('maintenance')}}</span>
          </a>
        </li>
        <li class="icon6" *ngIf="authUser.user_permissions.amenities" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(2)}">
          <a href="/#/amenity/book" title="Amenities" [ngStyle]="linkStyle()">
            <i class="fas fa-calendar-alt"></i>
            <span class="icon-sub show-mobile">{{t('amenities')}}</span>
          </a>
        </li>
        <li class="icon4" *ngIf="authUser.user_permissions.communications" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(3)}">
          <a href="/#/messages" title="Messages" [ngStyle]="linkStyle()">
            <i class="fas fa-envelope"></i>
            <span class="icon-sub show-mobile">{{t('messages')}}</span>
          </a>
          <span id="qmessage"></span>
        </li>
        <li class="icon5 hide-mobile" *ngIf="authUser.user_permissions.payments" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(4)}">
          <a href="/#/payments/history" title="History" [ngStyle]="linkStyle()">
            <i class="fas fa-history"></i>
            <span class="icon-sub">{{t('payment_history')}}</span>
          </a>
        </li>
        <li class="icon5 hide-mobile" *ngIf="authUser.user_permissions.parcels" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(5)}">
          <a href="/#/parcels" title="Parcels" [ngStyle]="linkStyle()">
            <i class="fas fa-box"></i>
            <span class="icon-sub">{{t('parcels')}}</span>
          </a>
        </li>
        <li class="icon6 hide-mobile" *ngIf="authUser.user_permissions.documents" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(6)}">
          <a href="/#/documents" title="Documents" [ngStyle]="linkStyle()">
            <i class="fas fa-file"></i>
            <span class="icon-sub">{{t('documents')}}</span>
          </a>
        </li>
        <li class="icon2 hide-mobile" *ngIf="authUser.insurance_nav" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(7)}">
          <a href="/#/services" title="Resident Insurance" [ngStyle]="linkStyle()">
            <i class="fas fa-concierge-bell"></i>
            <span class="icon-sub">{{t('residents_services')}}</span>
          </a>
        </li>
        <li class="icon6 hide-mobile" *ngIf="authUser.rewards" [ngClass]="{'hide-mobile': isMenuItemActiveInMobile(8)}">
          <a href="/#/rewards" title="Promotions" [ngStyle]="linkStyle()">
            <i class="fas fa-gift"></i>
            <span class="icon-sub">{{t('rewards')}}</span>
          </a>
        </li>
        <li class="show-mobile-override">
          <a href="javascript:void(0)" class="more-nav collapsed"
             data-toggle="collapse"
             data-target="#navbar-collapse-3-ng"
             [ngStyle]="{color: branding.primary_colour}">
            <i class="fas fa-ellipsis-h"></i>
            <span class="icon-sub show-mobile">{{t('more')}}</span>
          </a>
        </li>
      </ul>

      <ul class="collapse nav navbar-nav navbar-right navbar-collapse  h-mobile" id="navbar-collapse-1-ng">
        <li class="dropdown">
          <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
            {{ localeButtonString }}
            <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li><a href="javascript:void(0)" (click)="setLocalization('en')">En</a></li>
            <li><a href="javascript:void(0)" (click)="setLocalization('fr')">Fr</a></li>
          </ul>
        </li>

        <li class="dropdown" *ngIf="authUser.linked_accounts.length > 1">
          <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
            {{t('change_user')}} <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" role="menu">
            <li *ngFor="let account of authUser.linked_accounts">
              <a href="javascript:void(0)" (click)="changeUser(account.id)" *ngIf="account.tenant">
                {{account.tenant.property.name}} {{t('unit')}} {{account.tenant.property_unit.unit}}
              </a>
              <a href="https://{{authUser.company_subdomain}}.leasing.payquad.com/#/n/login" target="_blank" *ngIf="account.permissions == 'applicant'">
                <i class="fa fa-file" aria-hidden="true"></i> Applicant: {{account.first_name}}  {{account.last_name}}   <i class="fa fa-external-link-alt fa-xs" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </li>

        <li class="dropdown">
          <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
            {{ t('welcome') }} {{ authUser.first_name }} {{ authUser.last_name }} <span class="caret"></span>
          </a>
          <ul class="dropdown-menu" role="menu">
            <li>
              <a href="/#/account">
                {{ t('profile') }}
              </a>
            </li>
          </ul>
        </li>
        <li class="sign-out">
          <a id="logout-btn" (click)="signOut()">
            {{ t('sign_out') }}
          </a>
        </li>
        <li class="support-centre">
          <a href="javascript:void(0)"
             class="info"
             data-toggle="modal"
             data-target=".support" title="{{t('support')}}">
            <img
              src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDM0IDM0IiBoZWlnaHQ9IjM0cHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzNCAzNCIgd2lkdGg9IjM0cHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxwYXRoIGQ9Ik0xNy4xMjMsOS4yYy0xLjQ0LDAtMi42NDIsMC41MDMtMy42MDQsMS4zMlMxMS45OTQsMTIsMTEuODMyLDE0aDIuOTM3YzAuMDY0LTEsMC4zMDMtMS4yMzEsMC43MTYtMS42MTEgICBzMC45MjYtMC42MTgsMS41NDEtMC42MThjMC42MTUsMCwxLjExNiwwLjE3NCwxLjUwNCwwLjU3MWMwLjM4OSwwLjM5NiwwLjU4MywwLjg4MiwwLjU4MywxLjQ4cy0wLjE4NywxLjA5NC0wLjU1OCwxLjQ5OSAgIGwtMS43NzIsMS43NjljLTAuNTE4LDAuNTE4LTAuNjI2LDAuOTM0LTAuNzgsMS4yNDlDMTUuODQ5LDE4LjY1NCwxNiwxOS4xMzMsMTYsMTkuNzhWMjFoMnYtMC44MzJjMC0wLjY0NiwwLjI4OS0xLjE0OCwwLjU4MS0xLjUwNCAgIGMwLjExMi0wLjEyOSwwLjMzMy0wLjI4NywwLjUyMS0wLjQ3M2MwLjE4Ni0wLjE4NywwLjQ0OC0wLjQwNSwwLjcxNS0wLjY1NmMwLjI2Ny0wLjI1LDAuNS0wLjQ1NywwLjY2Mi0wLjYxOSAgIGMwLjE2MS0wLjE2MSwwLjQwNC0wLjQzNywwLjcxMi0wLjgyNWMwLjUzMy0wLjY0NywwLjgwNS0xLjQ1NiwwLjgwNS0yLjQyN2MwLTEuNDA4LTAuNDUtMi41MDMtMS4zNTYtMy4yODkgICBDMTkuNzMyLDkuNTkyLDE4LjU2Myw5LjIsMTcuMTIzLDkuMnoiIGZpbGw9IiMyMzFGMjAiLz48cGF0aCBkPSJNMTYuOTQsMjIuMTQ1Yy0wLjUxLDAtMC45NDYsMC4xNzktMS4zMTEsMC41MzRjLTAuMzY0LDAuMzU2LTAuNTQ2LDAuNzgtMC41NDYsMS4yNzQgICBjMCwwLjQ5MywwLjE4NiwwLjkxNCwwLjU1OCwxLjI2MmMwLjM3MiwwLjM0OCwwLjgxMywwLjUyMSwxLjMyMiwwLjUyMWMwLjUxLDAsMC45NDctMC4xNzgsMS4zMTEtMC41MzMgICBjMC4zNjMtMC4zNTYsMC41NDYtMC43ODEsMC41NDYtMS4yNzRzLTAuMTg3LTAuOTE0LTAuNTU5LTEuMjYzQzE3Ljg5MSwyMi4zMTgsMTcuNDUsMjIuMTQ1LDE2Ljk0LDIyLjE0NXoiIGZpbGw9IiMyMzFGMjAiLz48cGF0aCBkPSJNMTcsMEM3LjYxMSwwLDAsNy42MTEsMCwxN3M3LjYxMSwxNywxNywxN3MxNy03LjYxMSwxNy0xN1MyNi4zODksMCwxNywweiBNMTcsMzFDOS4yNjgsMzEsMywyNC43MzIsMywxNyAgIEMzLDkuMjY4LDkuMjY4LDMsMTcsM2M3LjczMiwwLDE0LDYuMjY4LDE0LDE0QzMxLDI0LjczMiwyNC43MzIsMzEsMTcsMzF6IiBmaWxsPSIjMjMxRjIwIi8+PC9nPjwvc3ZnPg=="/></a>
        </li>
      </ul>
    </div>
  </div>
  <div id="navbar-collapse-3-ng" class="nav-expand-mobile collapse">
    <ul data-toggle="collapse" data-target="#navbar-collapse-3">
      <li class="icon5" [ngClass]="{'hide-mobile': !isMenuItemActiveInMobile(4)}">
        <a href="/#/payments/history" title="History" ng-click="hideNav('#navbar-collapse-3')">
          <i class="fas fa-history"></i>
          {{t('payment_history')}}
        </a>
      </li>
      <li class="icon5" *ngIf="authUser.user_permissions.parcels" [ngClass]="{'hide-mobile': !isMenuItemActiveInMobile(5)}">
        <a href="/#/parcels" title="Parcels">
          <i class="fas fa-box"></i>
          {{t('parcels')}}
        </a>
      </li>
      <li class="icon6" *ngIf="authUser.rewards" [ngClass]="{'hide-mobile': !isMenuItemActiveInMobile(8)}">
        <a href="/#/rewards" title="Promotions">
          <i class="fas fa-gift"></i>
          {{t('rewards')}}
        </a>
      </li>
      <li class="icon6" *ngIf="authUser.user_permissions.documents" [ngClass]="{'hide-mobile': !isMenuItemActiveInMobile(6)}">
        <a href="/#/documents" title="Documents">
          <i class="fas fa-file"></i>
          {{t('documents')}}
        </a>
      </li>
      <li class="icon2" *ngIf="authUser.insurance_nav" [ngClass]="{'hide-mobile': !isMenuItemActiveInMobile(7)}">
        <a href="/#/services" title="Resident Insurance">
          <i class="fas fa-concierge-bell"></i>
          {{t('residents_services')}}
        </a>
      </li>
      <li>
        <a href="/#/account/">
          <i class="fas fa-user-circle"></i>
          {{t('profile')}}
        </a>
      </li>
      <li class="dropdown">
        <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
          <i class="fas fa-globe-americas"></i>
          {{ localeButtonString }}
        </a>
        <ul class="dropdown-menu">
          <li><a href="javascript:void(0)" (click)="setLocalization('en')">En</a></li>
          <li><a href="javascript:void(0)" (click)="setLocalization('fr')">Fr</a></li>
        </ul>
      </li>
      <li class="dropdown" ng-if="authUser.linked_accounts.length > 1">
        <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
          {{t('change_user')}} <span class="caret"></span>
        </a>
        <ul class="dropdown-menu" role="menu">
          <li *ngFor="let account of authUser.linked_accounts">
            <a href="javascript:void(0)" (click)="changeUser(account.id)" *ngIf="account.tenant">
              {{account.tenant.property.name}} {{t('unit')}} {{account.tenant.property_unit.unit}}
            </a>
            <a href="https://{{authUser.company_subdomain}}.leasing.payquad.com/#/n/login" target="_blank" *ngIf="account.permissions == 'applicant'">
              <i class="fa fa-file" aria-hidden="true"></i> Applicant: {{account.first_name}}  {{account.last_name}}   <i class="fa fa-external-link-alt fa-xs" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </li>
      <li class="sign-out">
        <a id="logout-btn" (click)="signOut()">
          <i class="fas fa-sign-out-alt"></i>
          {{ t('sign_out') }}
        </a>
      </li>
    </ul>
  </div>
</nav>
</div>
